import React from "react";
import { InteractiveMapEditor } from "./InteractiveMapEditor";
import { MapSettingsPanel } from "./MapSettingsPanel";

export const InteractiveMapPage = () => {
  const [tab, setTab] = React.useState(0);

  return (
    <>
      {tab === 0 && <InteractiveMapEditor tab={tab} onTabChange={setTab} />}
      {tab === 1 && <MapSettingsPanel tab={tab} onTabChange={setTab} />}
    </>
  );
};
